var $ = jQuery;

if (!adjustDdSize) {
  var adjustDdSize = function () {
    //console.log("calling adjustDdSize");
    var $this = $(this);
    $this.parent().find(".tt-dropdown-menu").width($this.css("width"));
  };
}

if (!substringMatcher) {
  var substringMatcher = function (strs) {
    return function findMatches(q, cb) {
      var matches, substringRegex;

      // an array that will be populated with substring matches
      matches = [];

      // regex used to determine if a string contains the substring `q`
      substrRegex = new RegExp(q, "i");

      // iterate through the pool of strings and for any string that
      // contains the substring `q`, add it to the `matches` array
      $.each(strs, function (i, str) {
        if (substrRegex.test(str)) {
          // the typeahead jQuery plugin expects suggestions to a
          // JavaScript object, refer to typeahead docs for more info
          matches.push({ value: str });
        }
      });

      cb(matches);
    };
  };
}

// if(!ga) {
//     // for clients not implementing Google Analytics.
//     var ga = function() {};
// }

(function ($) {
  var substringMatcher = function (strs) {
    return function findMatches(q, cb) {
      var matches, substringRegex;

      // an array that will be populated with substring matches
      matches = [];

      // regex used to determine if a string contains the substring `q`
      substrRegex = new RegExp(q, "i");

      // iterate through the pool of strings and for any string that
      // contains the substring `q`, add it to the `matches` array
      $.each(strs, function (i, str) {
        if (substrRegex.test(str)) {
          // the typeahead jQuery plugin expects suggestions to a
          // JavaScript object, refer to typeahead docs for more info
          matches.push({ value: str });
        }
      });

      cb(matches);
    };
  };

  var adjustDdSize = function () {
    //console.log("calling adjustDdSize");
    var $this = $(this);
    $this.parent().find(".tt-dropdown-menu").width($this.css("width"));
  };

  var doNotQualify = false; //flag addr to get details, etc but do not set as a qualified address (no check for availability)

  $.fn.lookupServiceAvailability = function (options) {
    if (options && options.doNotQualify) {
      doNotQualify = options.doNotQualify;
    }

    var addressQualBase = "https://addressqualificationdev.nscom.com",
      addressQualCreds = "Basic YXFsaWI6ZDk5NWtBMSNyMiE=";

    $.ajax({
      url: "/wp-content/themes/lumos-tidewater/api_helper.php",
      type: "GET",
      dataType: "json",
      async: false,
      data: {
        action: "get_ns_address_val_creds",
      },
      success: function (result) {
        // console.log(result);

        addressQualBase = result.url;
        addressQualCreds = result.access;

        // console.log(addressQualBase, addressQualCreds);
      },
    });

    $.fn.lookupServiceAvailability.defaults = {
      // scriptBase: "https://cdnqa.nscom.com/js/aqui/",
      scriptBase: globals.aq_cdn + "/js/aqui/",
      typeahead_url:
        "https://cdnjs.cloudflare.com/ajax/libs/corejs-typeahead/0.10.3/typeahead.jquery.min.js",
      addressQualificationBase: addressQualBase,
      auth_header: addressQualCreds,
      typeahead_opts: {
        hint: true,
        highlight: true,
        minLength: 3,
      },
      statuses: {},
    };

    $.fn.lookupServiceAvailability.aptOptions = [];
    $.fn.lookupServiceAvailability.AccountID = null;
    // console.log($.fn.lookupServiceAvailability.SelectedAddress);
    if (!$.fn.lookupServiceAvailability.SelectedAddress) {
      $.fn.lookupServiceAvailability.SelectedAddress = null;
    }
    // console.log($.fn.lookupServiceAvailability.SelectedAddress);

    options = $.extend({}, $.fn.lookupServiceAvailability.defaults, options);
    // console.log('script base', options.scriptBase);

    var elem = this;

    $.fn.lookupServiceAvailability.aptSelectedHandler = function (selection) {
      //console.log(selection);
      $.fn.lookupServiceAvailability.SelectedAddress = selection.addrdata;
    };

    var bindGoogleAddressTypeAhead = function (elem) {
      return $(elem).typeahead(options.typeahead_opts, {
        source: function (query, process) {
          //console.log(query);
          query = query.replace(/\ /g, "+");

          console.log("googleplacelookup 1");

          var addrPass = $.ajax({
            url: "/wp-content/themes/lumos-tidewater/assets/static/lumos_address_qual_pixel_googleplacelookup.html",
            async: false,
            success: function (response) {
              // console.log(response);
              return true;
            },
            error: function () {
              window.location.href = "/access-error/";
              return false;
            },
          });

          if (addrPass) {
            return $.getJSON(
              options.scriptBase + "/googleplacelookup.php",
              { action: "autocomplete", query: query },
              function (data) {
                outdata = [];
                if (data.status == "OK") {
                  outdata = $.map(data.predictions, function (obj, idx) {
                    return {
                      place_id: obj.place_id,
                      value: obj.description
                        .replace(/, United States/, "")
                        .replace(/, USA/, ""),
                      terms: obj.terms,
                    };
                  });
                } else {
                  $(elem).trigger("noMatchOnGooglePlaces", query);
                }
                return process(outdata);
              }
            );
          }
        },
      });
    };

    $.fn.lookupServiceAvailability.googleAddressTypeAheadSelectedHandler =
      function (elem, event, selection) {
        //console.log(selection);
        //console.log(options);

        setLoadState(true, elem);

        var place_id =
          typeof selection !== "undefined" ? selection.place_id : "xxxxxxxx";

        var addrPassV = $.ajax({
          url: "/wp-content/themes/lumos-tidewater/assets/static/lumos_address_qual_pixel_googleplacelookup.html",
          async: false,
          success: function (response) {
            // console.log(response);
            return true;
          },
          error: function () {
            window.location.href = "/access-error/";
            return false;
          },
        });

        if (addrPassV) {
          var addrPass = $.ajax({
            url: options.scriptBase + "/googleplacelookup.php",
            type: "GET",
            dataType: "json",
            async: false,
            data: {
              action: "geocode",
              query: selection.value,
            },
            success: function (result) {
              // console.log(url);
              place_id =
                result.results.length > 0
                  ? result.results[0].place_id
                  : "xxxxx";
              //console.log(place_id);

              for (
                var i = 0;
                i < result.results[0].address_components.length;
                i++
              ) {
                var component = result.results[0].address_components[i];
                if (component.types[0] == "postal_code") {
                  // console.log(component.long_name);
                  $("[id^=checkaddress]").attr("data-zip", component.long_name);
                  break;
                }
              }
            },
            complete: function () {
              return $.ajax({
                url:
                  options.addressQualificationBase +
                  "/GetAddressByGooglePlaceId/" +
                  place_id,
                async: true,
                type: "GET",
                dataType: "json",
                beforeSend: function (xhr) {
                  xhr.setRequestHeader("Authorization", options.auth_header);
                },
                success: function (result) {
                  if (result.Status == "success") {
                    addressData = result.Data;

                    envConsoleLog("addressData", addressData);

                    if (addressData.length > 1) {
                      $.fn.lookupServiceAvailability.aptOptions = $.map(
                        result.Data,
                        function (val, idx) {
                          return { addrdata: val, value: val.ApartmentNum };
                        }
                      );

                      // set the SelectedAddress to the result with no ApartmentNum
                      var addr = _.filter(result.Data, function (addr) {
                        return addr.ApartmentNum == null;
                      });
                      $.fn.lookupServiceAvailability.SelectedAddress = addr[0];
                    } else {
                      $.fn.lookupServiceAvailability.SelectedAddress =
                        addressData[0];
                    }
                    // console.log(elem, addressData);
                    if (addressData) {
                      $(elem).trigger("foundAddressByGooglePlaceId", [
                        addressData,
                      ]);
                    }
                  }
                },
                error: function () {
                  $(elem).trigger("addressByGooglePlaceIdNotFound", selection);
                },
                complete: function () {
                  setTimeout(function () {
                    if ($("#street1").length && $("#street1").val().length) {
                      $("#checkaddress").prop("disabled", false);
                      $("#street1").prop("disabled", true);
                      $("#geolocate-button").prop("disabled", true);
                      $("#resetaddressform").removeClass("hide");
                    }
                    // Block Element Default
                    if (
                      $("#street1-header").length &&
                      $("#street1-header").val().length
                    ) {
                      $("#checkaddress-header").prop("disabled", false);
                      $("#street1-header").prop("disabled", true);
                      $("#geolocate-button-header").prop("disabled", true);
                      $("#resetaddressform-header").removeClass("hide");

                      $.fn.aqui.loadGoogleSearchForm($(".aqui-container"));
                    }
                    // Block Element with alt classes
                    var altClasses = [
                      "alternative-checker",
                      "white-checker",
                      "vertical-checker",
                      "hp-white-checker",
                      // "no-qual-adr-lookup"
                    ];
                    $.each(altClasses, function (key, altClass) {
                      if (
                        $("#street1-header" + altClass).length &&
                        $("#street1-header" + altClass).val().length
                      ) {
                        $("#checkaddress-header" + altClass).prop(
                          "disabled",
                          false
                        );
                        $("#street1-header" + altClass).prop("disabled", true);
                        $("#geolocate-button-header" + altClass).prop(
                          "disabled",
                          true
                        );
                        $("#resetaddressform-header" + altClass).removeClass(
                          "hide"
                        );
                      }
                    });

                    setLoadState(false, elem);
                  }, 250);
                },
              });
            },
          });
        }
      };

    $.when(jQuery().typeahead || $.getScript(options.typeahead_url)).done(
      function () {
        bindGoogleAddressTypeAhead(elem)
          .on("typeahead:selected", function (event, selection) {
            $("#loading-icon").show();
            $("#checkaddress, .reset-address-form, .check-address").attr(
              "disabled",
              "disabled"
            );
            // console.log(elem, event, selection);
            $.fn.lookupServiceAvailability.googleAddressTypeAheadSelectedHandler(
              elem,
              event,
              selection
            );
            $("#loading-icon").hide();
            $("#checkaddress, .reset-address-form, .check-address").removeAttr(
              "disabled"
            );
            //console.log('typeahead:selected:stop');
            // console.log(selection.terms[3].value);
            // console.log(elem);

            $("[id^=checkaddress]").attr(
              "data-street",
              selection.terms[1].value.toUpperCase()
            );
            $("[id^=checkaddress]").attr(
              "data-city",
              selection.terms[2].value.toUpperCase()
            );
            $("[id^=checkaddress]").attr(
              "data-state",
              selection.terms[3].value.toUpperCase()
            );
            $("[id^=checkaddress]").attr(
              "data-country",
              selection.terms[4].value.toUpperCase()
            );

            // This could probably be refactored into something better, but this works for now.
            switch (elem.attr("id")) {
              case "street1-header":
                $("#checkaddress-header").attr(
                  "data-state",
                  selection.terms[3].value
                );
                break;
              case "street1-headeralternative-checker":
                $("#checkaddress-headeralternative-checker").attr(
                  "data-state",
                  selection.terms[3].value
                );
                break;
              default:
                $("#checkaddress").attr("data-state", selection.terms[3].value);
                break;
            }
          })
          .on("typeahead:opened", function (event) {
            //console.log("typeahead:opened");
          });
      }
    );

    return this.each(function () {
      var elem = $(this);
    });
  };

  $.fn.aqui = function (options) {
    var addressQualBase = "https://addressqualificationdev.nscom.com",
      addressQualCreds = "Basic YXFsaWI6ZDk5NWtBMSNyMiE=";

    $.ajax({
      url: "/wp-content/themes/lumos-tidewater/api_helper.php",
      type: "GET",
      dataType: "json",
      async: false,
      data: {
        action: "get_ns_address_val_creds",
      },
      success: function (result) {
        // console.log(result);

        addressQualBase = result.url;
        addressQualCreds = result.access;

        // console.log(addressQualBase, addressQualCreds);
      },
    });
    let currentURL = window.location.href.split("?")[0].replace(/\/?$/, "/"); // remove slash and query params

    $.fn.aqui.stage1_defaults = {
      // scriptBase: "https://cdnqa.nscom.com/js/aqui",
      scriptBase: globals.aq_cdn + "/js/aqui",
      // addressQualificationBase: "https://addressqualificationdev.nscom.com",
      addressQualificationBase: addressQualBase,
      websiteBase: "https://northstate.smallfootprint.net",
      themeBase: currentURL + "wp-content/themes/lumos-tidewater",
    };

    stage1_options = $.extend({}, $.fn.aqui.stage1_defaults, options);

    $.fn.aqui.defaults = {
      scriptBase: stage1_options.scriptBase,
      addressQualificationBase: stage1_options.addressQualificationBase,
      address_id: null,
      typeahead_url:
        "https://cdnjs.cloudflare.com/ajax/libs/corejs-typeahead/0.10.3/typeahead.jquery.min.js",
      fastclick_url:
        "https://cdnjs.cloudflare.com/ajax/libs/fastclick/1.0.6/fastclick.min.js",
      inputmask_url:
        "https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.3/jquery.mask.min.js",
      geolocation_url:
        "https://cdnjs.cloudflare.com/ajax/libs/jQuery-Geolocation/1.0.50/jquery.geolocation.min.js",
      validaion_url:
        "https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.15.0/jquery.validate.min.js",
      // auth_header: 'Basic YXFsaWI6ZDk5NWtBMSNyMiE=',
      auth_header: addressQualCreds,
      street_field: "",
      underscore_url:
        "https://cdnjs.cloudflare.com/ajax/libs/underscore.js/1.8.3/underscore-min.js",
      zipcodes_url: stage1_options.addressQualificationBase + "/GetZipCodes/",
      citiesbyzip_url:
        stage1_options.addressQualificationBase + "/GetCitiesByZip/",
      streetsbycity_url:
        stage1_options.addressQualificationBase + "/GetStreetsByCity/",
      housenumbersbystreet_url:
        stage1_options.addressQualificationBase + "/GetHouseNumbersByStreet/",
      aptnumbersbyhousenumber_url:
        stage1_options.addressQualificationBase +
        "/GetApartmentNumbersByHouseNumber/",
      addressbyId_url:
        stage1_options.addressQualificationBase + "/GetAddressById/",
      informRequest_url:
        stage1_options.addressQualificationBase + "/InformRequest/",
      // getFiber_url: stage1_options.websiteBase + "/ShopFiber?page=PAGETOKEN&address=ADDRESSTOKEN&product=PRODUCTTOKEN",
      // myAccount_url: stage1_options.websiteBase + "/MyAccount/Authenticate",
      getFiber_url:
        stage1_options.websiteBase +
        "/shop-fiber?page=PAGETOKEN&address=ADDRESSTOKEN&product=PRODUCTTOKEN",
      myAccount_url: stage1_options.websiteBase + "/account-login",
      statuses: {},
      templates: {
        dropdown_search_form:
          stage1_options.scriptBase + "/dropdown-search-form.html",
        address_lookup_result:
          stage1_options.scriptBase + "/address-lookup-result.html",
        google_search_form:
          stage1_options.scriptBase + "/google-search-form.html",
        cookies_not_enabled:
          "/wp-content/themes/lumos-tidewater/assets/aquitemplates/cookies-not-enabled.html",
        results: {
          account_exist_fiber_available:
            stage1_options.scriptBase +
            "/results_templates/account-exist-fiber-available.html",
          account_exist_fiber_not_available:
            stage1_options.scriptBase +
            "/results_templates/account-exist-fiber-not-available.html",
          fiber_available_start_screen:
            stage1_options.scriptBase +
            "/results_templates/fiber-available-start-screen.html",
          fiber_available_congrat:
            stage1_options.scriptBase +
            "/results_templates/fiber-available-congrat.html",
          fiber_available_congrat_lumos:
            stage1_options.scriptBase +
            "/results_templates/fiber-available-congrat-lumos.html",
          fiber_coming_soon:
            stage1_options.scriptBase +
            "/results_templates/fiber-coming-soon.html",
          low_tier_fiber_not_available:
            stage1_options.scriptBase +
            "/results_templates/low-tier-fiber-not-available.html",
          no_services_planned:
            stage1_options.scriptBase + "/results_templates/no-services.html", // Nicer message. old: "/results_templates/no-services-planned.html"
          no_services:
            stage1_options.scriptBase + "/results_templates/no-services.html",
          address_not_found:
            stage1_options.scriptBase +
            "/results_templates/address-not-found.html",
          email_interstitial:
            stage1_options.themeBase +
            "/assets/aquitemplates/results_templates/email-interstitial.html",
        },
      },
      messages: {
        serviceRqCommingSoonMsg:
          "<p>Thank you for your interest in Lumos fiber service. We have added your contact information to our Fiber Updates list and we will notify you when that service is available in your area.</p>",
        serviceRqFiberNotAvailableMsg:
          "<p>Thank you for your interest in Lumos fiber service. We have added your contact information to our Fiber Updates list and we will notify you when that service is available in your area.</p>",
        //serviceRqCooperAvailableMsg: "<p>Thank you for your interest in North State’s fiber service. We have added your contact information to our Fiber Updates list and we will notify you when that service is available in your area.<\/p>",
        serviceRqCooperAvailableMsg:
          "<p>Your request has been received. A Customer Service Representative will contact you soon to discuss the services that are available in your area. Thank you for choosing Lumos.</p>",
        serviceRqBusinessMsg:
          "<p>Your request has been received. A Customer Service Representative will contact you soon to discuss the services that are available to your business. Thank you for choosing Lumos.</p>",
        prospectRqMsg:
          "<p>Thank you for your interest in Lumos fiber service. We will contact you about service.</p>",
      },
      informRequestSource: null,
    };

    var tmpl_cache = {};

    if (options) {
      if (
        typeof options.templates !== "undefined" &&
        typeof options.templates.results !== "undefined"
      ) {
        options.templates.results = $.extend(
          {},
          $.fn.aqui.defaults.templates.results,
          options.templates.results
        );
      }
      if (typeof options.templates !== "undefined") {
        options.templates = $.extend(
          {},
          $.fn.aqui.defaults.templates,
          options.templates
        );
      }
      if (typeof options.messages !== "undefined") {
        options.messages = $.extend(
          {},
          $.fn.aqui.defaults.messages,
          options.messages
        );
      }
    }

    options = $.extend({}, $.fn.aqui.defaults, options);

    var elem = this;

    $.fn.aqui.selector = $(this).selector;

    var bindAptTypeAhead = function (aptElem) {
      $(aptElem).typeahead("destroy");
      return $(aptElem).typeahead(
        {
          hint: true,
          highlight: true,
          minLength: 0,
        },
        {
          source: function (query, process) {
            //console.log("APTS", $(elem).find("#street1").lookupServiceAvailability.aptOptions);

            x = $.map(
              $(elem).find("#street1").lookupServiceAvailability.aptOptions,
              function (val, idx) {
                if (val.value == null) {
                  val.value = "";
                }
                return { value: val.value, addrdata: val.addrdata };
              }
            );

            x = _.sortBy(x, "value");

            process(x);
          },
        }
      );
    };

    var ShowCheckAddressMessage = function (selector, html, elem) {
      // console.log(selector, html, elem);
      envConsoleLog("ShowCheckAddressMessage", selector, html, elem);
      $(elem).html(html);

      envConsoleLog("html element swapped");
      $(".check-message").removeClass("active");
      $(".get-more-info-form").removeClass("active");
      setTimeout(function () {
        $(selector).addClass("active");
      }, 500);
      $("#check-address").parent().removeClass("active");
      $(".styled-form.bottom-form ").removeClass("active");
      $(elem).trigger("checkAddressMessageRendered", selector);
    };

    var getTemplatePartial = function (template_url, return_full_html = true) {
      // envConsoleLog("fetching partial:", template_url);
      var fetchedContent = null;
      $.ajax({
        url: template_url,
        method: "GET",
        async: false,
        dataType: "html",
        success: function (data) {
          // envConsoleLog("data", data);
          fetchedContent = data;

          // return full html flag to prevent our theme from re-adding scripts,etc.
          if (!return_full_html) {
            var tempDiv = document.createElement("div");
            var bodyContent = data.match(/<body[^>]*>((.|[\n\r])*)<\/body>/im);
            if (bodyContent && bodyContent.length > 1) {
              tempDiv.innerHTML = bodyContent[1];
            } else {
              tempDiv.innerHTML = data;
            }

            var emailInterstitial = tempDiv.querySelector(
              "#email-interstitial"
            );
            if (emailInterstitial) {
              fetchedContent = emailInterstitial.outerHTML;
            } else {
              console.error(
                "#email-interstitial not found in the fetched template"
              );
            }
          }
        },
        error: function () {
          console.error("unabled to fetch template from " + template_url);
        },
      });
      return fetchedContent;
    };

    $.fn.aqui.ShowCheckAddressMessage = ShowCheckAddressMessage;
    $.fn.aqui.getTemplatePartial = getTemplatePartial;

    var ComposeFullAddress = function (n, t) {
      var i = "";
      return (
        t != undefined && t != ""
          ? (i = "PO Box " + t)
          : (n.HouseNumber != null && (i = n.HouseNumber.HouseNum),
            n.Street != null &&
              (i =
                i +
                (n.Street.PreDirectional == null
                  ? ""
                  : " " + n.Street.PreDirectional) +
                " " +
                n.Street.Street +
                (n.Street.StreetSuffix == null
                  ? ""
                  : " " + n.Street.StreetSuffix) +
                (n.Street.PostDirectional == null
                  ? ""
                  : " " + n.Street.PostDirectional)),
            n.ApartmentNum != null &&
              (i = i.trim() + " " + n.ApartmentNum.ApartmentNum)),
        n.City != null &&
          (i =
            i.trim() +
            ", " +
            n.City.City +
            "," +
            (n.City.StateAbbreviation == null
              ? ""
              : " " + n.City.StateAbbreviation)),
        n.Zip != null && n.Zip != 0 && (i = i.trim() + " " + n.Zip),
        i
      );
    };

    $.fn.aqui.informRequest = function (formData, msg) {
      d = new Date();
      formData.Timestamp = d.toISOString();
      if (!options.informRequestSource) {
        var href = $(location).attr("href");
        if (href.length > 200) {
          href = href.substring(0, 200) + "..";
        }
        options.informRequestSource = href;
      }
      formData.Source = options.informRequestSource;
      //console.log(formData);

      $.ajax({
        url: options.informRequest_url,
        async: false,
        type: "POST",
        data: JSON.stringify(formData),
        contentType: "application/json",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", options.auth_header);
        },
        success: function (response) {
          addr = response.Data;
          //console.log(addr);
          if (typeof msg === "function") {
            msg();
          } else {
            $("#informSuccessMessage .message").html(msg);
          }

          $(".check-message").removeClass("active");
          $(".get-more-info-form").removeClass("active");
          $(".get-more-info-form select").each(function () {
            $(this).find("option:first").prop("selected", !0).change();
          });
          $("#informSuccessMessage").addClass("active");
        },
      });
    };

    $.fn.aqui.hubspotRequest = function (formData, msg) {
      var hsFormData = {
        fields: [
          {
            name: "firstname",
            value: formData.FirstName,
          },
          {
            name: "lastname",
            value: formData.LastName,
          },
          {
            name: "phone",
            value: formData.Phone,
          },
          {
            name: "email",
            value: formData.Email,
          },
          {
            name: "address",
            value: formData.AddressStreet,
          },
          {
            name: "city",
            value: formData.AddressCity,
          },
          {
            name: "state",
            value: formData.AddressState,
          },
          {
            name: "segment",
            value: formData.Segment,
          },
        ],
        legalConsentOptions: {
          consent: {
            // Include this object when GDPR options are enabled
            consentToProcess: true,
            text: "I agree to allow Example Company to store and process my personal data.",
            communications: [
              {
                value: true,
                subscriptionTypeId: 999,
                text: "I agree to receive marketing communications from Example Company.",
              },
            ],
          },
        },
      };

      $.ajax({
        type: "POST",
        url: "https://api.hsforms.com/submissions/v3/integration/submit/20327025/faaf2155-3914-4f0e-9e03-ee722d466a87",
        cache: false,
        contentType: "application/json",
        processData: false,
        data: JSON.stringify(hsFormData),
        success: function (data) {
          // console.log("Hubspot Submission was successful.");
          // console.log(data);

          if (typeof msg === "function") {
            msg();
          } else {
            $("#informSuccessMessage .message").html(msg);
          }

          $(".check-message").removeClass("active");
          $(".get-more-info-form").removeClass("active");
          $(".get-more-info-form select").each(function () {
            $(this).find("option:first").prop("selected", !0).change();
          });
          $("#informSuccessMessage").addClass("active");
        },
      });
    };

    $.fn.aqui.salesforceRequest = function (formData, msg) {
      envConsoleLog("salesforceRequest", formData, msg);
      // prepare the data in the format required by Salesforce
      var sfFormData = {
        FirstName: formData.FirstName,
        LastName: formData.LastName,
        Phone: formData.Phone,
        Email: formData.Email,
        ContactKey: formData.Email,
        Address:
          formData.AddressStreet +
          (formData.AddressUnitNo ? ", " + formData.AddressUnitNo : "") +
          ", " +
          formData.AddressCity +
          ", " +
          formData.AddressState +
          ", " +
          formData.AddressZip,
        Street: formData.AddressStreet,
        City: formData.AddressCity,
        State: formData.AddressState,
        Zip: formData.AddressZip,
        UnitNo: formData.AddressUnitNo ?? "",
        Segment: formData.Segment,
        ConsentToProcess: true,
        MarketingCommunicationConsent: true,
      };

      // Function to handle form submission
      function submitToSalesforce(formAction) {
        $.ajax({
          url: "/wp-content/themes/lumos-tidewater/api_helper.php",
          type: "GET",
          dataType: "json",
          async: false,
          data: {
            action: "get_server_info",
          },
          success: function (result) {
            var externalKey = "";
            var clientId = "";
            var dripKey = "";
            // if using dev aq (indicating dev env), use dev keys
            if (!(result.env === "live")) {
              customerKey = "DB017DA9-FCBA-4A80-B38A-2CF98EA73459";
              clientId = "534009359";
              externalKey = "8E021F13-1147-461E-BA6A-B5AEF47E4E6C";
            } else {
              // live site keys
              customerKey = "D26D8941-01CC-4F0E-82B2-F60D64009ACF";
              clientId = "534005590";
              externalKey = "AC51C76F-FF4C-4B2A-BDAF-04CA4D19290B";
            }
            // Prepare the FormData object
            var sfRequestData = new FormData();
            for (var key in sfFormData) {
              sfRequestData.append(key, sfFormData[key]);
            }
            // Add additional Salesforce-specific fields
            sfRequestData.append("_clientId", clientId);
            sfRequestData.append("_deExternalKey", externalKey);
            sfRequestData.append("_action", formAction);
            sfRequestData.append("_returnXML", "0");
            sfRequestData.append("_successURL", "https://example.com/success");
            sfRequestData.append("_errorURL", "https://example.com/error");

            // Perform the AJAX request to Salesforce
            $.ajax({
              type: "POST",
              url: "https://cl.s12.exct.net/DEManager.aspx", // Update with Salesforce endpoint if different
              cache: false,
              processData: false,
              contentType: false,
              data: sfRequestData,
              success: function (data) {
                if (typeof msg === "function") {
                  msg();
                } else {
                  $("#informSuccessMessage .message").html(msg);
                }
                $(".check-message").removeClass("active");
                $(".get-more-info-form").removeClass("active");
                $(".get-more-info-form select").each(function () {
                  $(this).find("option:first").prop("selected", !0).change();
                });
                $("#informSuccessMessage").addClass("active");
              },
            });
          },
        });
      }

      submitToSalesforce("add");
    };

    $.fn.aqui.checkAddress = function (elem, addr, altaddr = "") {
      var tmpl_opts = {};
      var url = options.templates.address_lookup_result;
      var html = "";
      let vwo_toggle = false;
      // envConsoleLog("checkAddress", elem, addr, altaddr);
      // [data-vwo-active] if true
      $("[data-vwo-active]").each(function () {
        var vwo_active = $(this).data("vwo-active");
        if (vwo_active) {
          vwo_toggle = true;
        }
      });

      // Check for user to have entered an email address if they are on a variant, or just proceed if not using promise
      var vwo_ac_email = localStorage.getItem("vwo_ac_email");

      const waitForEmailSubmission = new Promise((resolve, reject) => {
        if (
          vwo_ac_email === "variant-b" &&
          !localStorage.getItem("lumos_address_email") &&
          vwo_toggle
        ) {
          // envConsoleLog("vwo ac email variant-b");

          let email_html = getTemplatePartial(
            options.templates.results.email_interstitial,
            false
          );
          ShowCheckAddressMessage("#email-interstitial", email_html, elem);

          var debounceTimeout;
          var $emailInput = $("#email-interstitial-email");
          var $submitBtn = $("#ga-submit-email");

          $emailInput.on("input", function () {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(checkEmail, 750);
          });

          function checkEmail() {
            var email = $emailInput.val();
            var pattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            var feedback = $emailInput.parent().siblings(".invalid-feedback");

            if (pattern.test(email)) {
              $emailInput.removeClass("is-invalid").addClass("is-valid");
              feedback.hide();
              setLoadState(true, $("#addressCheckerModal"));

              $.ajax({
                url: "/wp-content/themes/lumos-tidewater/api_helper.php",
                type: "GET",
                contentType: "application/x-www-form-urlencoded",
                data: {
                  action: "check_username",
                  username: email,
                },
                success: function (result) {
                  var response = jQuery.parseJSON(result);

                  if (response.Status === "success" && response.Data) {
                    $emailInput.removeClass("is-valid").addClass("is-invalid");
                    feedback.text("This email is already in use.");
                    feedback.show();
                    $submitBtn.attr("disabled", true);
                  } else {
                    $emailInput.removeClass("is-invalid").addClass("is-valid");
                    feedback.hide();
                    $submitBtn.attr("disabled", false);
                  }
                },
                complete: function () {
                  setLoadState(false, $("#addressCheckerModal"));
                },
                error: function (xhr, status, error) {
                  console.error("Error checking username: " + error);
                  feedback.text("An error occurred. Please try again.");
                  feedback.show();
                },
              });
            } else {
              $emailInput.removeClass("is-valid").addClass("is-invalid");
              feedback.text("Please enter a valid email address.");
              feedback.show();
              $submitBtn.attr("disabled", true);
            }
          }

          $("#ga-submit-email").on("click", function () {
            var emailInput = $("#email-interstitial-email");
            var feedback = emailInput.parent().next(".invalid-feedback");
            // Force validation on submit
            emailInput.trigger("input");
            let email = emailInput.val();
            localStorage.setItem("lumos_address_email", email);
            window.VWO = window.VWO || [];
            VWO.event =
              VWO.event ||
              function () {
                VWO.push(["event"].concat([].slice.call(arguments)));
              };
            VWO.event("emailCaptured");
            resolve(); // Resolve to continue after submitting email
          });

          $(".change-address").on("click", function () {
            logNSEvent("ecomm - button click - Change Address");
            logJourney({
              action: "button click",
              status: "n/a",
              additionalInfo: "Change Address",
            });
            // console.log("change-address");
            $.fn.aqui.loadGoogleSearchForm(elem);
          });
        } else {
          resolve(); // If not variant-b, resolve immediately
        }
      });

      waitForEmailSubmission.then(() => {
        envConsoleLog("waitForEmailSubmission.then");
        if (addr) {
          envConsoleLog("addr", addr);
          var compiled_template = null;
          envConsoleLog("loading template from " + url);
          $.loadTemplate(url)
            .then(function (data) {
              envConsoleLog("template loaded");
              compiled_template = _.template(data);
              var fiber_url = options.getFiber_url
                .replace("PAGETOKEN", "shop")
                .replace("PRODUCTTOKEN", 1)
                .replace("ADDRESSTOKEN", addr.Id);

              tmpl_opts = {
                getFiber_url: fiber_url,
                myAccount_url: options.myAccount_url,
              };
            })
            .then(function () {
              var predirection = addr.hasOwnProperty("PreDirectional")
                ? addr.PreDirectional == null
                  ? ""
                  : addr.PreDirectional + " "
                : "";
              var postdirection =
                addr.PostDirectional == null ? "" : " " + addr.PostDirectional;
              r =
                predirection +
                addr.StreetName +
                (addr.StreetSuffix == null ? "" : " " + addr.StreetSuffix) +
                postdirection;

              // console.log(addr);

              localStorage.removeItem("lumos_address_market");
              document.cookie =
                "STYXKEY_lumos_address_market=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

              var addrNewStack = addr.NewStack;

              localStorage.setItem("lumos_address_tech_stack", "legacy");
              // New Stack Address Check
              if (addrNewStack === 1) {
                if (addr.AccountID != 0 && addr.AccountID != null) {
                  logNSEvent(
                    "ecomm - address checker - SF Account Exists: " +
                      addr.FullAddress
                  );
                  logJourney({
                    action: "address checker",
                    status: "Account Exists",
                    street: addr.FullAddress,
                    full_response: JSON.stringify(addr),
                  });
                  tmpl_opts["result_template"] = getTemplatePartial(
                    options.templates.results.account_exist_fiber_available
                  );
                  html = compiled_template(tmpl_opts);
                  html = _.template(html)(tmpl_opts);
                  ShowCheckAddressMessage(
                    "#account-exist-fiber-available",
                    html,
                    elem
                  );
                } else {
                  envConsoleLog("New Stack Address Check");
                  localStorage.setItem(
                    "lumos_address_tech_stack",
                    "salesforce"
                  );
                  document.cookie =
                    "STYXKEY_lumos_address_market=tidewater; path=/;";
                  localStorage.setItem("lumos_address_market", "tidewater");

                  if (typeof show5GigSpeedcard == "function") {
                    show5GigSpeedcard();
                  }

                  logNSEvent(
                    "ecomm - address checker - Service Available: " +
                      addr.FullAddress
                  );
                  logJourney({
                    action: "address checker",
                    status: "Service Available",
                    street: addr.FullAddress,
                    full_response: JSON.stringify(addr),
                  });

                  tmpl_opts["result_template"] = getTemplatePartial(
                    options.templates.results.fiber_available_congrat
                  );
                  tmpl_opts["AddressID"] = addr.UniversalAddressID;
                  tmpl_opts["AddressStreet"] = addr.HouseNum + " " + r;
                  tmpl_opts["AddressCity"] = addr.City;
                  tmpl_opts["AddressState"] = addr.State;
                  tmpl_opts["AddressUnitNo"] = addr.ApartmentNum ?? "";
                  html = compiled_template(tmpl_opts);
                  html = _.template(html)(tmpl_opts);
                  ShowCheckAddressMessage(
                    "#fiber-available-congrat",
                    html,
                    elem
                  );
                  // updatePageProducts();
                }
                // Old Stack Address Check
              } else if (addrNewStack === 2) {
                // coming soon new stacker

                logNSEvent(
                  "ecomm - address checker - Fiber Coming Soon: " +
                    addr.FullAddress
                );
                logJourney({
                  action: "address checker",
                  status: "Fiber Coming Soon",
                  street: addr.FullAddress,
                  full_response: JSON.stringify(addr),
                });
                tmpl_opts["result_template"] = getTemplatePartial(
                  options.templates.results.fiber_coming_soon
                );
                tmpl_opts["serviceRqCommingSoonMsg"] =
                  options.messages.serviceRqCommingSoonMsg;
                tmpl_opts["AddressID"] = addr.Id;
                tmpl_opts["AddressStreet"] = addr.HouseNum + " " + r;
                tmpl_opts["AddressCity"] = addr.City;
                tmpl_opts["AddressState"] = addr.State;
                tmpl_opts["AddressZip"] = addr.Zip;
                tmpl_opts["AddressUnitNo"] = addr.ApartmentNum ?? "";
                html = compiled_template(tmpl_opts);
                html = _.template(html)(tmpl_opts);
                ShowCheckAddressMessage("#fiber-coming-soon", html, elem);
              } else {
                envConsoleLog("Old Stack Address Check");
                if (
                  (addr.FiberNIDBit == 0 || addr.FiberNIDBit == null) &&
                  addr.LumosSamID !== null &&
                  addr.LumosService !== null &&
                  addr.LumosService !== ""
                ) {
                  if (addr.LumosService.toLowerCase() == "fiber") {
                    // tmpl_opts["result_template"] = getTemplatePartial(options.templates.results.fiber_available_congrat);
                    // tmpl_opts["AddressID"] = addr.Id;
                    // tmpl_opts["AddressStreet"] = addr.HouseNum + ' ' + r;
                    // tmpl_opts["AddressCity"] = addr.City;
                    // tmpl_opts["AddressState"] = addr.State;
                    // html = compiled_template(tmpl_opts);
                    // html = _.template(html)(tmpl_opts);
                    // ShowCheckAddressMessage("#fiber-available-congrat", html, elem);
                    updatePageProducts();

                    localStorage.setItem("lumos_address_market", "va");
                    document.cookie =
                      "STYXKEY_lumos_address_market=va; path=/;";

                    if (typeof show5GigSpeedcard == "function") {
                      show5GigSpeedcard();
                    }

                    logNSEvent(
                      "ecomm - address checker - Service Available: " +
                        addr.FullAddress
                    );
                    logJourney({
                      action: "address checker",
                      status: "Available",
                      street: addr.FullAddress,
                      full_response: JSON.stringify(addr),
                    });
                    tmpl_opts["result_template"] = getTemplatePartial(
                      options.templates.results.fiber_available_congrat
                    );
                    tmpl_opts["AddressID"] = addr.Id;
                    tmpl_opts["AddressStreet"] = addr.HouseNum + " " + r;
                    tmpl_opts["AddressCity"] = addr.City;
                    tmpl_opts["AddressState"] = addr.State;
                    tmpl_opts["AddressUnitNo"] = addr.ApartmentNum ?? "";
                    html = compiled_template(tmpl_opts);
                    html = _.template(html)(tmpl_opts);
                    ShowCheckAddressMessage(
                      "#fiber-available-congrat",
                      html,
                      elem
                    );
                    updatePageProducts();
                  } else {
                    tmpl_opts["result_template"] = getTemplatePartial(
                      options.templates.results.low_tier_fiber_not_available
                    );
                    tmpl_opts["serviceRqCooperAvailableMsg"] =
                      options.messages.serviceRqCooperAvailableMsg;
                    tmpl_opts["AddressID"] = addr.Id;
                    tmpl_opts["AddressStreet"] = addr.HouseNum + " " + r;
                    tmpl_opts["AddressCity"] = addr.City;
                    tmpl_opts["AddressState"] = addr.State;
                    tmpl_opts["AddressUnitNo"] = addr.ApartmentNum ?? "";
                    html = compiled_template(tmpl_opts);
                    html = _.template(html)(tmpl_opts);
                    logJourney({
                      action: "address checker",
                      status: "Low Tier Service Not Available",
                      street: addr.FullAddress,
                      full_response: JSON.stringify(addr),
                    });
                    ShowCheckAddressMessage(
                      "#low-tier-fiber-not-available",
                      html,
                      elem
                    );
                  }
                } else {
                  if (addr.AccountID != 0 && addr.AccountID != null) {
                    if (addr.FiberNIDBit && addr.SupportsGigabit) {
                      logNSEvent(
                        "ecomm - address checker - Account Exists: " +
                          addr.FullAddress
                      );
                      logJourney({
                        action: "address checker",
                        status: "Account Exists",
                        street: addr.FullAddress,
                        full_response: JSON.stringify(addr),
                      });
                      tmpl_opts["result_template"] = getTemplatePartial(
                        options.templates.results.account_exist_fiber_available
                      );
                      html = compiled_template(tmpl_opts);
                      html = _.template(html)(tmpl_opts);
                      ShowCheckAddressMessage(
                        "#account-exist-fiber-available",
                        html,
                        elem
                      );
                    } else {
                      logNSEvent(
                        "ecomm - address checker - Account Exists/Fiber Not Available: " +
                          addr.FullAddress
                      );

                      logJourney({
                        action: "address checker",
                        status: "Account Exists/Fiber Not Available",
                        street: addr.FullAddress,
                        full_response: JSON.stringify(addr),
                      });

                      tmpl_opts["result_template"] = getTemplatePartial(
                        options.templates.results
                          .account_exist_fiber_not_available
                      );
                      html = compiled_template(tmpl_opts);
                      html = _.template(html)(tmpl_opts);
                      ShowCheckAddressMessage(
                        "#account-exist-fiber-not-available",
                        html,
                        elem
                      );
                    }
                  } else {
                    if (addr.FiberNIDBit && addr.SupportsGigabit) {
                      localStorage.setItem("lumos_address_market", "nc");
                      document.cookie =
                        "STYXKEY_lumos_address_market=nc; path=/;";

                      if (typeof show5GigSpeedcard == "function") {
                        show5GigSpeedcard();
                      }

                      logNSEvent(
                        "ecomm - address checker - Service Available: " +
                          addr.FullAddress
                      );

                      logJourney({
                        action: "address checker",
                        status: "Available",
                        street: addr.FullAddress,
                        full_response: JSON.stringify(addr),
                      });

                      tmpl_opts["result_template"] = getTemplatePartial(
                        options.templates.results.fiber_available_congrat
                      );
                      tmpl_opts["AddressID"] = addr.Id;
                      tmpl_opts["AddressStreet"] = addr.HouseNum + " " + r;
                      tmpl_opts["AddressCity"] = addr.City;
                      tmpl_opts["AddressState"] = addr.State;
                      tmpl_opts["AddressUnitNo"] = addr.ApartmentNum ?? "";
                      html = compiled_template(tmpl_opts);
                      html = _.template(html)(tmpl_opts);
                      ShowCheckAddressMessage(
                        "#fiber-available-congrat",
                        html,
                        elem
                      );
                      updatePageProducts();
                    } else {
                      var futureFiber = "";
                      // if (addr.FutureFiberServices !== null) {
                      //   futureFiber = addr.FutureFiberServices;
                      // }
                      if (addr.FutureFiberServicesDate !== null) {
                        futureFiber = addr.FutureFiberServicesDate;
                      }

                      if (
                        (addr.FiberNIDBit && !addr.SupportsGigabit) ||
                        (!addr.FiberNIDBit && futureFiber !== "")
                        // futureFiber.toLowerCase().indexOf("gbps available") >= 0
                      ) {
                        logNSEvent(
                          "ecomm - address checker - Fiber Coming Soon: " +
                            addr.FullAddress
                        );
                        logJourney({
                          action: "address checker",
                          status: "Fiber Coming Soon",
                          street: addr.FullAddress,
                          full_response: JSON.stringify(addr),
                        });
                        tmpl_opts["result_template"] = getTemplatePartial(
                          options.templates.results.fiber_coming_soon
                        );
                        tmpl_opts["serviceRqCommingSoonMsg"] =
                          options.messages.serviceRqCommingSoonMsg;
                        tmpl_opts["AddressID"] = addr.Id;
                        tmpl_opts["AddressStreet"] = addr.HouseNum + " " + r;
                        tmpl_opts["AddressCity"] = addr.City;
                        tmpl_opts["AddressState"] = addr.State;
                        tmpl_opts["AddressZip"] = addr.Zip;
                        tmpl_opts["AddressUnitNo"] = addr.ApartmentNum ?? "";
                        html = compiled_template(tmpl_opts);
                        html = _.template(html)(tmpl_opts);
                        ShowCheckAddressMessage(
                          "#fiber-coming-soon",
                          html,
                          elem
                        );
                      } else {
                        if (
                          !addr.CopperNIDBit ||
                          addr.FiberNIDBit ||
                          addr.SupportsGigabit
                        ) {
                          if (
                            addr.FiberNIDBit ||
                            addr.SupportsGigabit ||
                            addr.CopperNIDBit
                          ) {
                            logNSEvent(
                              "ecomm - address checker - No Service Planned: " +
                                addr.FullAddress
                            );
                            logJourney({
                              action: "address checker",
                              status: "No Service",
                              street: addr.FullAddress,
                              additionalInfo: "No Service Planned",
                              full_response: JSON.stringify(addr),
                            });
                            tmpl_opts["result_template"] = getTemplatePartial(
                              options.templates.results.no_services_planned
                            );
                            tmpl_opts["serviceRqFiberNotAvailableMsg"] =
                              options.messages.serviceRqFiberNotAvailableMsg;
                            tmpl_opts["AddressID"] = addr.Id;
                            tmpl_opts["AddressStreet"] =
                              addr.HouseNum + " " + r;
                            tmpl_opts["AddressCity"] = addr.City;
                            tmpl_opts["AddressState"] = addr.State;
                            tmpl_opts["AddressZip"] = addr.Zip;
                            tmpl_opts["AddressUnitNo"] =
                              addr.ApartmentNum ?? "";
                            html = compiled_template(tmpl_opts);
                            html = _.template(html)(tmpl_opts);
                            ShowCheckAddressMessage(
                              // "#no-services-planned",
                              "#no-services",
                              html,
                              elem
                            );
                          } else {
                            logNSEvent(
                              "ecomm - address checker - No Services: " +
                                addr.FullAddress
                            );
                            logJourney({
                              action: "address checker",
                              status: "No Service",
                              street: addr.FullAddress,
                              full_response: JSON.stringify(addr),
                            });

                            tmpl_opts["result_template"] = getTemplatePartial(
                              options.templates.results.no_services
                            );
                            tmpl_opts["serviceRqFiberNotAvailableMsg"] =
                              options.messages.serviceRqFiberNotAvailableMsg;
                            tmpl_opts["AddressID"] = addr.Id;
                            tmpl_opts["AddressStreet"] =
                              addr.HouseNum + " " + r;
                            tmpl_opts["AddressCity"] = addr.City;
                            tmpl_opts["AddressState"] = addr.State;
                            tmpl_opts["AddressZip"] = addr.Zip;
                            tmpl_opts["AddressUnitNo"] =
                              addr.ApartmentNum ?? "";
                            html = compiled_template(tmpl_opts);
                            html = _.template(html)(tmpl_opts);
                            ShowCheckAddressMessage("#no-services", html, elem);
                          }
                        } else {
                          logNSEvent(
                            "ecomm - address checker - Low Tier Service Not Available: " +
                              addr.FullAddress
                          );
                          logJourney({
                            action: "address checker",
                            status: "Low Tier Service Not Available",
                            street: addr.FullAddress,
                            full_response: JSON.stringify(addr),
                          });
                          tmpl_opts["result_template"] = getTemplatePartial(
                            options.templates.results
                              .low_tier_fiber_not_available
                          );
                          tmpl_opts["serviceRqCooperAvailableMsg"] =
                            options.messages.serviceRqCooperAvailableMsg;
                          tmpl_opts["AddressID"] = addr.Id;
                          tmpl_opts["AddressStreet"] = addr.HouseNum + " " + r;
                          tmpl_opts["AddressCity"] = addr.City;
                          tmpl_opts["AddressState"] = addr.State;
                          tmpl_opts["AddressUnitNo"] = addr.ApartmentNum ?? "";
                          html = compiled_template(tmpl_opts);
                          html = _.template(html)(tmpl_opts);
                          ShowCheckAddressMessage(
                            "#low-tier-fiber-not-available",
                            html,
                            elem
                          );
                        }
                      }
                    }
                  }
                }
              }

              if ($(".checkPhoneUS").length > 0) {
                $(".checkPhoneUS").mask("000-000-0000");
              }

              $("[data-qual-address]").text(
                addr.HouseNum + " " + r.toUpperCase()
              );
              $("[data-qual-city]").text(addr.City.toUpperCase());

              $("#fiber-available-congrat").addClass(addr.State.toUpperCase());
              $("#fiber-available-congrat").attr(
                "data-state",
                addr.State.toUpperCase()
              );

              $(".change-address").on("click", function () {
                logNSEvent("ecomm - button click - Change Address");
                logJourney({
                  action: "button click",
                  status: "n/a",
                  additionalInfo: "Change Address",
                });
                // console.log("change-address");
                $.fn.aqui.loadGoogleSearchForm(elem);
              });
            });
        } else {
          envConsoleLog("noaddr");
          var compiled_template = null;
          $.loadTemplate(url)
            .then(function (data) {
              compiled_template = _.template(data);

              tmpl_opts = {
                myAccount_url: options.myAccount_url,
              };
            })
            .then(function () {
              var aptNum = $("#aptNo").val()
                ? " (Apt:" + $("#aptNo").val() + ")"
                : " ";
              logNSEvent(
                "ecomm - address checker - No Services At Address (2): " +
                  $("#houseNo").val() +
                  " " +
                  $("#streetName").val() +
                  " " +
                  $("#city").val() +
                  " " +
                  $("#zip").val() +
                  aptNum
              );

              if (altaddr == null || altaddr == "" || altaddr == undefined) {
                let altaddr = "";
              }
              logJourney({
                action: "address checker 2",
                status: "No Service",
                street: buildAddress(),
                full_response: JSON.stringify(altaddr),
              });

              // console.log("alt addr:", altaddr);

              tmpl_opts["result_template"] = getTemplatePartial(
                options.templates.results.address_not_found
              );
              tmpl_opts["serviceRqFiberNotAvailableMsg"] =
                options.messages.serviceRqFiberNotAvailableMsg;
              tmpl_opts["AddressStreet"] = altaddr.streetAddress.trim();
              tmpl_opts["AddressCity"] = altaddr.city.trim();
              tmpl_opts["AddressState"] = altaddr.state.trim();
              tmpl_opts["AddressZip"] = $("#zip").val();
              tmpl_opts["AddressUnitNo"] = aptNum;
              console.log(tmpl_opts);
              html = compiled_template(tmpl_opts);
              html = _.template(html)(tmpl_opts);
              ShowCheckAddressMessage("#address-not-found", html, elem);
              $(".change-address").on("click", function () {
                logNSEvent("ecomm - button click - Change Address");
                logJourney({
                  action: "button click",
                  status: "n/a",
                  additionalInfo: "Change Address",
                });
                // console.log("change-address");
                $.fn.aqui.loadGoogleSearchForm(elem);
              });
            });
        }

        $(".change-address").on("click", function () {
          logNSEvent("ecomm - button click - Change Address");
          logJourney({
            action: "button click",
            status: "n/a",
            additionalInfo: "Change Address",
          });
          // console.log("change-address");
          $.fn.aqui.loadGoogleSearchForm(elem);
        });
      });
    };

    $.fn.aqui.fetchAddrById = function (addressId) {
      var addr = null;

      var addrPass = $.ajax({
        url: "/wp-content/themes/lumos-tidewater/assets/static/lumos_address_qual_pixel_GetAddressById.html",
        async: false,
        success: function (response) {
          // console.log(response);
          return true;
        },
        error: function () {
          window.location.href = "/access-error/";
          return false;
        },
      });

      if (addrPass) {
        $.ajax({
          url: options.addressbyId_url + addressId,
          async: false,
          beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", options.auth_header);
          },
          success: function (response) {
            addr = response.Data;
          },
        });
        return addr;
      }
    };

    $.fn.aqui.loadDropDownSearchForm = function (elem) {
      var url = options.templates.dropdown_search_form;

      $.loadTemplate(url).then(function (data) {
        $(elem).html(_.template(data));

        //console.log(options);

        $.ajax({
          url: options.zipcodes_url,
          type: "GET",
          async: false,
          dataType: "json",
          beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", options.auth_header);
          },
          success: function (result) {
            //console.log("fetched zip codes");
            zipcodes = result.Data;
          },
        });

        setupAddressDropDownTypeahead("#zip", "zip", zipcodes);

        cities = [];

        function debounce(func, wait, immediate) {
          var timeout;
          return function () {
            var context = this,
              args = arguments;
            var later = function () {
              timeout = null;
              if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
          };
        }

        $("#zip").on("keydown", adjustDdSize);
        $("#city").on("keydown", adjustDdSize);
        $("#streetName").on("keydown", adjustDdSize);
        $("#houseNo").on("keydown", adjustDdSize);
        $("#aptNo").on("keydown", adjustDdSize);

        $("#zip").on("blur change", function (event) {
          //console.log("zip " + event.type);
          $("#city").val("");
          $("#streetName").val("");
          $("#houseNo").val("");
          $("#aptNo").val("");
          if (event.type == "change") {
            return false;
          }
          var val = $(this).val();
          populateZip(val);
        });

        $("#city").on("blur change", function (event) {
          //console.log("city " + event.type);
          $("#streetName").val("");
          $("#houseNo").val("");
          $("#aptNo").val("");
          if (event.type == "change") {
            return false;
          }
          var val = $(this).val();
          populateCity(val);
        });

        $("#streetName").on("blur change", function (event) {
          //console.log("streetName " + event.type);
          $("#houseNo").val("");
          $("#aptNo").val("");
          if (event.type == "change") {
            return false;
          }
          var val = $(this).val();
          populateStreet(val);
        });

        $("#houseNo").on("blur change", function (event) {
          //console.log("houseNo " + event.type);
          $("#aptNo").val("");
          if (event.type == "change") {
            return false;
          }
          var val = $(this).val();
          populateHouseNumber(val);
        });

        $("form#check-address input[placeholder]").on("focus", function () {
          $(this).data("placeholder", $(this).attr("placeholder"));
          $(this).attr("placeholder", "");
        });

        $("form#check-address input[placeholder]").on("blur", function () {
          $(this).attr("placeholder", $(this).data("placeholder"));
        });

        $("#dropdown_checkaddress").on("click", function () {
          aptoNum = $("#aptNo").val() || "";
          aptaddr = ApartmentNumberObj[aptoNum];

          if ($("#aptNo").val().length == 0 || typeof aptaddr === "undefined") {
            HouseNum = $("#houseNo").val();
            houseaddr = HouseNumberObj[HouseNum];
            if (houseaddr) {
              var addrID = houseaddr.Id;
              if (houseaddr.UniversalAddressID) {
                addrID = houseaddr.UniversalAddressID;
              }
              addressObj = $.fn.aqui.fetchAddrById(addrID);
              $.fn.lookupServiceAvailability.SelectedAddress = addressObj;
              var altaddr = "";
              if (!addressObj) {
                var citystate = $("#city").val().split(",");
                var city = "";
                var state = "";
                if (citystate.length > 1) {
                  city = citystate[0];
                  state = citystate[1];
                }
                altaddr = {
                  streetAddress:
                    $("#houseNo").val() + " " + $("#streetName").val(),
                  city: city,
                  state: state,
                };
              }
              $.fn.aqui.checkAddress(elem, addressObj, altaddr);
            } else {
              var citystate = $("#city").val().split(",");
              var city = "";
              var state = "";
              if (citystate.length > 1) {
                city = citystate[0];
                state = citystate[1];
              }
              var altaddr = {
                streetAddress:
                  $("#houseNo").val() + " " + $("#streetName").val(),
                city: city,
                state: state,
              };
              $.fn.aqui.checkAddress(elem, null, altaddr);
            }
          } else {
            var addrID = aptaddr.Id;
            if (aptaddr.UniversalAddressID) {
              addrID = aptaddr.UniversalAddressID;
            }
            addressObj = $.fn.aqui.fetchAddrById(addrID);
            var altaddr = "";
            if (!addressObj) {
              var citystate = $("#city").val().split(",");
              var city = "";
              var state = "";
              if (citystate.length > 1) {
                city = citystate[0];
                state = citystate[1];
              }
              altaddr = {
                streetAddress:
                  $("#houseNo").val() + " " + $("#streetName").val(),
                city: city,
                state: state,
              };
            }
            $.fn.lookupServiceAvailability.SelectedAddress = addressObj;
            $.fn.aqui.checkAddress(elem, addressObj, altaddr);
          }

          pushGA4Address("check_address_2", {
            street: $(this).attr("data-street"),
            city: $(this).attr("data-city"),
            state: $(this).attr("data-state"),
            postal_code: $(this).attr("data-zip"),
            country: "USA",
          });
        });
        //json = {"CityID":"130097","City":"GREENSBORO","StateID":"1038","State":"NORTH CAROLINA","StateAbbreviation":"NC","Zip":"27401","MetroAreaID":"100006"};

        $(".change-address").on("click", function () {
          logNSEvent("ecomm - button click - Change Address");
          logJourney({
            action: "button click",
            status: "n/a",
            additionalInfo: "Change Address",
          });
          // console.log("change-address");
          $.fn.aqui.loadGoogleSearchForm(elem);
        });
      });

      var HouseNumberObj = [];
      var CitiesObj = [];
      var StreetsObj = [];
      var ApartmentNumberObj = [];

      var zipcodes = [];
      var cities = [];
      var streets = [];
      var housenumbers = [];
      var apartmentnumbers = [];

      function setupAddressDropDownTypeahead(selector, dataSetName, dataSet) {
        //console.log("setupAddressDropDownTypeahead:",selector, dataSetName, dataSet);
        $(selector).typeahead("destroy");
        $(selector).typeahead(
          {
            hint: true,
            highlight: true,
            minLength: 0,
            limit: 5,
          },
          {
            name: dataSetName,
            source: () => {
              substringMatcher(dataSet);
              envConsoleLog("dataSet", selector, dataSet);
            },
          }
        );

        $(selector).on(
          "typeahead:selected change",
          function (event, selection) {
            var zip = $("#zip").val();
            var citystate = $("#city").val().split(",");
            var street = $("#streetName").val().toUpperCase();
            var state = "";

            // console.log(selection);

            if (zip.length > 1) {
              $("#dropdown_checkaddress").attr("data-zip", zip);
            }

            if (citystate.length > 1) {
              city = citystate[0].trim().toUpperCase();
              state = citystate[1].trim().toUpperCase();

              $("#dropdown_checkaddress").attr("data-city", city);
              $("#dropdown_checkaddress").attr("data-state", state);
            }

            if (street.length > 1) {
              $("#dropdown_checkaddress").attr("data-street", street);
            }
          }
        );

        $(selector).one("focus", function () {
          if ($(this).val().length > 0) {
            return false;
          }
          //console.log(selector +" focused")
          var ev = $.Event("keydown");
          ev.keyCode = ev.which = 40;
          $(selector).trigger(ev);
          return true;
        });
      }

      function populateZip(Zip) {
        if (Zip.length === 5) {
          cities.length = 0;
          $.ajax({
            url: options.citiesbyzip_url + Zip,
            async: true,
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", options.auth_header);
            },
            success: function (response) {
              Cities = response.Data;

              if (Cities !== null) {
                for (var c in Cities) {
                  if (typeof Cities[c].CityID !== "undefined") {
                    CitiesObj[
                      Cities[c].City.toString().trim() +
                        ", " +
                        Cities[c].StateAbbreviation.toString().trim()
                    ] = Cities[c];
                    cities.push(
                      Cities[c].City.toString().trim() +
                        ", " +
                        Cities[c].StateAbbreviation.toString().trim()
                    );
                  }
                }

                setupAddressDropDownTypeahead("#city", "cities", cities);
                $("#city").trigger("focus");
              } else {
                showAlert("error", "No cities found for the given zip...");
              }
            },
          });
        }
      }

      function populateCity(City) {
        if (City.length !== 0) {
          streets.length = 0;
          City = City.toUpperCase();
          $.ajax({
            url: options.streetsbycity_url,
            type: "POST",
            dataType: "json",
            async: true,
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", options.auth_header);
            },
            data: { City: JSON.stringify(CitiesObj[City]) },
            success: function (response) {
              Streets = response.Data;
              if (Streets !== null) {
                for (var s in Streets) {
                  if (typeof Streets[s].StreetID !== "undefined") {
                    var street = "";
                    street +=
                      Streets[s].PreDirectional === null
                        ? ""
                        : Streets[s].PreDirectional.toString().trim() + " ";
                    street += Streets[s].Street.toString().trim();
                    street +=
                      Streets[s].StreetSuffix === null
                        ? ""
                        : " " + Streets[s].StreetSuffix.toString().trim();
                    street +=
                      Streets[s].PostDirectional === null
                        ? ""
                        : " " + Streets[s].PostDirectional.toString().trim();

                    StreetsObj[street] = Streets[s];
                    streets.push(street);
                  }
                }

                setupAddressDropDownTypeahead(
                  "#streetName",
                  "streets",
                  streets
                );
                $("#streetName").trigger("focus");
              } else {
                showAlert("error", "No streets found for the given city...");
              }
            },
          });
        }
      }

      function populateStreet(Street) {
        if (Street.length !== 0) {
          Street = Street.toUpperCase();
          housenumbers.length = 0;
          $.ajax({
            url: options.housenumbersbystreet_url,
            type: "POST",
            dataType: "json",
            async: true,
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", options.auth_header);
            },
            data: {
              action: "GetHouseNumbersByStreet",
              Street: JSON.stringify(StreetsObj[Street]),
            },
            success: function (response) {
              HouseNumbers = response.Data;
              if (HouseNumbers !== null) {
                for (var h in HouseNumbers) {
                  if (typeof HouseNumbers[h].HouseNum !== "undefined") {
                    if (HouseNumbers[h].HouseNumSuffix !== null) {
                      HouseNumbers[h].HouseNum =
                        HouseNumbers[h].HouseNum +
                        " " +
                        HouseNumbers[h].HouseNumSuffix;
                    }

                    HouseNumberObj[HouseNumbers[h].HouseNum] = HouseNumbers[h];
                    housenumbers.push(HouseNumbers[h].HouseNum);
                  }
                }

                setupAddressDropDownTypeahead(
                  "#houseNo",
                  "housenumbers",
                  housenumbers
                );
                $("#houseNo").trigger("focus");
              } else {
                showAlert(
                  "error",
                  "No house numbers found for the given street..."
                );
              }
            },
          });
        }
      }

      function populateHouseNumber(HouseNum) {
        if (HouseNum.length !== 0) {
          apartmentnumbers.length = 0;
          $.ajax({
            url: options.aptnumbersbyhousenumber_url,
            type: "POST",
            dataType: "json",
            async: false,
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", options.auth_header);
            },
            data: {
              action: "GetApartmentNumbersByHouseNumber",
              HouseNumber: JSON.stringify(HouseNumberObj[HouseNum]),
            },
            success: function (response) {
              ApartmentNumbers = response.Data;
              if (ApartmentNumbers !== null) {
                for (var h in ApartmentNumbers) {
                  if (typeof ApartmentNumbers[h].ApartmentNum !== "undefined") {
                    ApartmentNumberObj[ApartmentNumbers[h].ApartmentNum] =
                      ApartmentNumbers[h];
                    apartmentnumbers.push(ApartmentNumbers[h].ApartmentNum);
                  }
                }

                setupAddressDropDownTypeahead(
                  "#aptNo",
                  "apartmentnumbers",
                  apartmentnumbers
                );
                $("#aptNo").trigger("focus");
              } else {
                //showAlert('error','No house numbers found for the given street...');
              }
            },
          });
        }
      }
    };

    $.fn.aqui.loadAddressAvailable = function (elem) {
      // if(localStorage.getItem('lumos_address_full_address') && localStorage.getItem('lumos_address_full_address').length) {
      var url = options.templates.results.fiber_available_start_screen;
      // }

      $.loadTemplate(url)
        .then(function (data) {
          $(elem).html(_.template(data));
        })
        .done(function () {});
    };

    $.fn.aqui.loadGoogleSearchForm = function (elem) {
      function reverseGeocodeMyPosition(position) {
        var latlng = position.coords.latitude + "," + position.coords.longitude;

        // console.log('googleplacelookup 3');

        // var addrPass = $.ajax({
        //   url: "/wp-content/themes/lumos-tidewater/assets/static/lumos_address_qual_pixel_googleplacelookup.html",
        //   async: false,
        //   success: function (response) {
        //     // console.log(response);
        //     return true;
        //   },
        //   error: function () {
        //     window.location.href = "/access-error/";
        //     return false;
        //   },
        // });
        //
        // if (addrPass) {

        $.getJSON(
          options.scriptBase + "/googleplacelookup.php",
          { action: "reverse_geocode", latlng: latlng },
          function (data) {
            if (data.place_id) {
              $("#street1").val(data.formatted_address.replace(/, USA/, ""));
              selection = {
                place_id: data.place_id,
                value: data.formatted_address,
                terms: [],
              };
              $.fn.lookupServiceAvailability
                .googleAddressTypeAheadSelectedHandler(elem, null, selection)
                .then(function () {
                  addressData = $.fn.lookupServiceAvailability.aptOptions;
                  foundAddressByGooglePlaceIdHandler(elem, null, addressData);
                });
            } else {
              alert("Accurate geo-location information unavailable.");
            }

            // Remove icon animation
            $(elem).find(".geolocate-icon").removeClass("checking");
            // .removeClass("fa-refresh")
            // .removeClass("fa-spin")
            // .addClass("fa-map-marker");
          }
        );

        // }
      }

      function noLocation(error) {
        alert("No location info available. Error code: " + error.code);
        // Remove icon animation
        $(elem).find(".geolocate-icon").removeClass("checking");
        // .removeClass("fa-refresh")
        // .removeClass("fa-spin")
        // .addClass("fa-map-marker");
      }

      function foundAddressByGooglePlaceIdHandler(elem, event, addressData) {
        //console.log("foundAddressByGooglePlaceIdHandler:", addressData);
        if (
          $(elem).find("#street1").lookupServiceAvailability.aptOptions.length >
          1
        ) {
          //console.log($(this).lookupServiceAvailability.aptOptions.length);
          $(elem).find(".apt-col").show();
          $(elem).addClass("includes-apt");

          bindAptTypeAhead($(elem).find("#aptNo").get(0)).on(
            "typeahead:selected",
            function (event, selection) {
              //console.log('typeahead:selected');
              //console.log(elem, event, selection);
              $.fn.lookupServiceAvailability.aptSelectedHandler(selection);
            }
          );

          $("#aptNo").one("keydown", adjustDdSize);
          $("#aptNo").on("focus", function () {
            //console.log('hello');
            var ev = $.Event("keydown");
            ev.keyCode = ev.which = 40;
            $("#aptNo").trigger(ev);
            return true;
          });
        } else {
          $(elem).find(".apt-elem").hide();
          $(elem).removeClass("includes-apt");
        }
      }

      var url = options.templates.google_search_form;

      // if(!isCookiesEnabled()) {
      //   url = options.templates.cookies_not_enabled;
      // }

      $.loadTemplate(url)
        .then(function (data) {
          $(elem).html(_.template(data));
        })
        .done(function () {
          $(elem)
            .find("[data-show-element]")
            .click(function () {
              $("#" + $(this).attr("data-show-element")).toggleClass("hide");
            });

          // console.log(options.scriptBase, options.addressQualificationBase, options.typeahead_url);

          $(elem).removeClass("includes-apt");
          $(elem)
            .find("#street1")
            .lookupServiceAvailability({
              scriptBase: options.scriptBase,
              addressQualificationBase: options.addressQualificationBase,
              typeahead_url: options.typeahead_url,
            })
            .on("foundAddressByGooglePlaceId", function (event, addressData) {
              foundAddressByGooglePlaceIdHandler(elem, event, addressData);
            })
            .on("addressByGooglePlaceIdNotFound", function (event, selection) {
              //console.log("addressByGooglePlaceIdNotFound:", selection);
            });

          var addressFormCount = Cookies.get("lumos_address_form_count");
          var addressLockoutCount = Cookies.get("lumos_address_lockout_count");
          var lockoutMinutes = 1440; // Lockout for 24 hours
          var lockoutExpires = (1 / 24 / 60) * lockoutMinutes;

          if (typeof addressFormCount === "undefined") {
            addressFormCount = 0;
          }
          if (typeof addressLockoutCount === "undefined") {
            addressLockoutCount = 0;
          }

          // console.log("addressFormCount", addressFormCount);
          // console.log("addressLockoutCount", addressLockoutCount);

          if (
            addressFormCount &&
            parseInt(addressFormCount) >= 5 //5 attempts
          ) {
            // console.log("disable form");
            $(elem).find("#street1").prop("disabled", true);
            $(elem).find("#checkaddress").prop("disabled", true);
            $(elem).find("#geolocate-button").prop("disabled", true);
            $(elem).find("#disabled-form-message").removeClass("hide");
            // if (parseInt(addressFormCount) == 5) {
            //   Cookies.set("lumos_address_form_count", 0);
            //   Cookies.set("lumos_lockout_count", ++addressLockoutCount);
            // }
          } else {
            $(elem).find("#street1").one("keydown", adjustDdSize);

            $(elem)
              .find("#street1")
              .on("change", function () {
                //console.log("change");
              });

            $(elem)
              .find("#checkaddress")
              .on("click", function () {
                var minutes = 10; // 10 minute lockout
                var expires = (1 / 24 / 60) * minutes;

                //console.log("clicked checkaddress");
                if (addressFormCount) {
                  var submissionCount = parseInt(addressFormCount);
                  submissionCount++;
                  Cookies.set("lumos_address_form_count", submissionCount, {
                    expires: expires,
                  });
                  if (submissionCount >= 5) {
                    Cookies.set(
                      "lumos_address_lockout_count",
                      ++addressLockoutCount,
                      {
                        expires: lockoutExpires,
                      }
                    );
                  }
                } else {
                  Cookies.set("lumos_address_form_count", 1, expires, {
                    expires: expires,
                  });
                }

                // Check for 20 attempts (4 lockouts) and impose 24 hour lockout
                if (addressLockoutCount >= 4) {
                  // console.log("24 hour lockout imposed");

                  Cookies.set(
                    "lumos_address_lockout_count",
                    ++addressLockoutCount
                  );

                  Cookies.set("lumos_address_form_count", 20, {
                    expires: lockoutExpires,
                  });
                  $("#disabled-form-message strong").text(
                    "Please wait 24 hours before checking another address."
                  );
                  Cookies.set("lumos_address_lockout_count", 0); // Reset lockout count
                }

                if (
                  $(elem).find("#street1").lookupServiceAvailability
                    .SelectedAddress
                ) {
                  $.fn.aqui.checkAddress(
                    elem,
                    $(elem).find("#street1").lookupServiceAvailability
                      .SelectedAddress
                  );
                  // $.fn.aqui.checkAddress(elem, $(elem).find("#street1").lookupServiceAvailability.SelectedAddress, altaddr);
                } else {
                  envConsoleLog("No Service");
                  logNSEvent(
                    "ecomm - address checker - Show Second Address Form: No Service Address: " +
                      $("#street1").val()
                  );
                  logJourney({
                    action: "address checker",
                    status: "No Service",
                    street: $("#street1").val(),
                    additionalInfo: "Show Second Address Form",
                  });
                  $.fn.aqui.loadDropDownSearchForm(elem);
                }

                pushGA4Address("check_address_1", {
                  street: $(this).attr("data-street"),
                  city: $(this).attr("data-city"),
                  state: $(this).attr("data-state"),
                  postal_code: $(this).attr("data-zip"),
                  country: $(this).attr("data-country"),
                });
              });

            // Clear Address Selection by clicking reset button
            $(elem)
              .find("#resetaddressform")
              .on("click", function () {
                $("#street1").val("");
                $("#street1").prop("disabled", false);
                $("#street1").lookupServiceAvailability.SelectedAddress = null;
                $("#checkaddress").prop("disabled", true);
                $("#resetaddressform").addClass("hide");
                $(".apt-col").hide();
              });

            // Clear Address Selection by clicking on the entry element
            $(elem)
              .find(".address-field-container")
              .on("click", function () {
                // console.log($("#street1").prop("disabled"));
                // if ($("#street1").prop("disabled")) {
                //   $("#resetaddressform").click();
                //   $("#street1").focus();
                // }
              });

            $(elem)
              .find("#geolocate-button")
              .on("click", function () {
                $.geolocation.get({
                  win: reverseGeocodeMyPosition,
                  fail: noLocation,
                });
                // Add icon animation
                $(elem).find(".geolocate-icon").addClass("checking");
                // .removeClass("fa-map-marker")
                // .addClass("fa-refresh")
                // .addClass("fa-spin");

                logNSEvent(
                  "ecomm - button click - Address Checker: Geolocate Button"
                );
                logJourney({
                  action: "button click",
                  status: "n/a",
                  additionalInfo: "Geolocate Click",
                });
              });
          }
        });
    };

    $.createCache = function (requestFunction) {
      var cache = {};
      return function (key, callback) {
        if (!cache[key]) {
          //console.log("cache  miss!");
          cache[key] = $.Deferred(function (defer) {
            //console.log("storing in cache");
            requestFunction(defer, key);
          }).promise();
        }
        return cache[key].done(callback);
      };
    };

    $.loadTemplate = $.createCache(function (defer, url) {
      envConsoleLog("loadTemplate with " + url);
      return $.ajax({
        url: url,
        method: "GET",
        async: false,
        dataType: "html",
        success: defer.resolve,
        error: defer.reject,
      });
    });

    $.when(
      typeof _ == "function" || $.getScript(options.underscore_url),
      jQuery().typeahead || $.getScript(options.typeahead_url),
      jQuery().geolocation || $.getScript(options.geolocation_url),
      jQuery().maskWatchers || $.getScript(options.inputmask_url),
      typeof FastClick == "function" || $.getScript(options.fastclick_url),
      jQuery.validator || $.getScript(options.validaion_url)
    ).done(function () {
      //console.log(options.typeahead_url);
      if (options.address_id) {
        // console.log(options);
        addrobj = $.fn.aqui.fetchAddrById(options.address_id);
        //console.log(options.address_id, addrobj);
        $.fn.lookupServiceAvailability.SelectedAddress = addrobj;
        $.fn.aqui.checkAddress(elem, addrobj);
      } else {
        if (
          localStorage.getItem("lumos_address_full_address") &&
          localStorage.getItem("lumos_address_full_address").length
        ) {
          $.fn.aqui.loadAddressAvailable(elem);
        } else {
          $.fn.aqui.loadGoogleSearchForm(elem);
        }

        //$.fn.aqui.loadDropDownSearchForm(elem);
      }
    });

    return this.each(function () {
      var elem = $(this);
    });
  };

  if ($("#street1-header").length) {
    $("#street1-header")
      .lookupServiceAvailability({
        scriptBase: globals.aq_cdn + "/js/aqui",
        addressQualificationBase: "https://addressqualification.nscom.com",
        typeahead_url:
          "https://cdnjs.cloudflare.com/ajax/libs/corejs-typeahead/0.10.3/typeahead.jquery.min.js",
      })
      .on("foundAddressByGooglePlaceId", function (event, addressData) {
        function foundAddressByGooglePlaceIdHandler(elem, event, addressData) {
          // console.log(addressData[0]);

          var bindAptTypeAhead_header = function (aptElem) {
            $(aptElem).typeahead("destroy");
            return $(aptElem).typeahead(
              {
                hint: true,
                highlight: true,
                minLength: 0,
              },
              {
                source: function (query, process) {
                  //console.log("APTS", $(elem).find("#street1").lookupServiceAvailability.aptOptions);
                  x = $.map(
                    $("#street1-header").lookupServiceAvailability.aptOptions,
                    function (val, idx) {
                      if (val.value == null) {
                        val.value = "";
                      }
                      return { value: val.value, addrdata: val.addrdata };
                    }
                  );

                  x = _.sortBy(x, "value");

                  process(x);
                },
                updater: function (item) {
                  envConsoleLog("updater");
                },
              }
            );
          };

          if (
            $("#street1-header").lookupServiceAvailability.aptOptions.length > 1
          ) {
            //console.log($(this).lookupServiceAvailability.aptOptions.length);
            $(elem).find(".apt-col").show();
            $(elem).addClass("includes-apt");

            bindAptTypeAhead_header($(elem).find("#aptNo-header").get(0)).on(
              "typeahead:selected",
              function (event, selection) {
                //console.log('typeahead:selected');
                //console.log(elem, event, selection);
                $.fn.lookupServiceAvailability.aptSelectedHandler(selection);
              }
            );

            $("#aptNo-header").one("keydown", adjustDdSize);
            $("#aptNo-header").on("focus", function () {
              //console.log('hello');
              var ev = $.Event("keydown");
              ev.keyCode = ev.which = 40;
              $("#aptNo-header").trigger(ev);
              return true;
            });
          } else {
            $(elem).find(".apt-elem").hide();
            $(elem).removeClass("includes-apt");
          }
        }

        foundAddressByGooglePlaceIdHandler(
          $(".wf-address-checker .header-address-checker"),
          event,
          addressData
        );
      })
      .on("addressByGooglePlaceIdNotFound", function (event, selection) {
        //console.log("addressByGooglePlaceIdNotFound:", selection);
      });

    $("#checkaddress-header").on("click", function () {
      //console.log("clicked checkaddress");
      // $('#address-checker').toggleClass('open');

      toggleAddressChecker();

      var minutes = 5;
      var expires = (1 / 24 / 60) * minutes;

      if (Cookies.get("lumos_address_form_count")) {
        var submissionCount = parseInt(Cookies.get("lumos_address_form_count"));
        submissionCount++;
        Cookies.set("lumos_address_form_count", submissionCount, {
          expires: expires,
        });
      } else {
        Cookies.set("lumos_address_form_count", 1, { expires: expires }); // 5 minutes
      }

      if ($("#street1-header").lookupServiceAvailability.SelectedAddress) {
        $.fn.aqui.checkAddress(
          $(".aqui-container"),
          $("#street1-header").lookupServiceAvailability.SelectedAddress
        );
        // $.fn.aqui.checkAddress($('.aqui-container'), $("#street1-header").lookupServiceAvailability.SelectedAddress, altaddr);
      } else {
        logNSEvent(
          "ecomm - address checker - Show Second Address Form: No Service Address: " +
            $("#street1-header").val()
        );
        logJourney({
          action: "address checker",
          status: "No Service",
          street: $("#street1-header").val(),
          additionalInfo: "Show Second Address Form",
        });
        $.fn.aqui.loadDropDownSearchForm($(".aqui-container"));
      }

      $("#resetaddressform-header").click(); // Reset form on submit
    });

    $("#geolocate-button-header").on("click", function () {
      $.geolocation.get({
        win: function (position) {
          var latlng =
            position.coords.latitude + "," + position.coords.longitude;
          var options = $.extend(
            {},
            $.fn.lookupServiceAvailability.defaults,
            options
          );

          // console.log('googleplacelookup 4');

          // var addrPass = $.ajax({
          //   url: "/wp-content/themes/lumos-tidewater/assets/static/lumos_address_qual_pixel_googleplacelookup.html",
          //   async: false,
          //   success: function (response) {
          //     // console.log(response);
          //     return true;
          //   },
          //   error: function () {
          //     window.location.href = "/access-error/";
          //     return false;
          //   },
          // });
          //
          // if (addrPass) {

          $.getJSON(
            options.scriptBase + "/googleplacelookup.php",
            { action: "reverse_geocode", latlng: latlng },
            function (data) {
              if (data.place_id) {
                $("#street1-header").val(
                  data.formatted_address.replace(/, USA/, "")
                );
                selection = {
                  place_id: data.place_id,
                  value: data.formatted_address,
                  terms: [],
                };
                $.fn.lookupServiceAvailability
                  .googleAddressTypeAheadSelectedHandler(
                    $("#street1-header"),
                    null,
                    selection
                  )
                  .then(function () {
                    addressData = $.fn.lookupServiceAvailability.aptOptions;
                    foundAddressByGooglePlaceIdHandler(
                      $("#street1-header"),
                      null,
                      addressData
                    );
                  });
              } else {
                alert("Accurate geo-location information unavailable.");
              }

              // Remove icon animation
              $("#geolocate-button-header")
                .find(".geolocate-icon")
                .removeClass("checking");
            }
          );

          // }
        },
        fail: function (error) {
          alert("No location info available. Error code: " + error.code);
          // Remove icon animation
          $("#geolocate-button-header")
            .find(".geolocate-icon")
            .removeClass("checking");
        },
      });

      // Add icon animation
      $(this).find(".geolocate-icon").addClass("checking");

      logNSEvent("ecomm - button click - Address Checker: Geolocate Button");
      logJourney({
        action: "button click",
        status: "n/a",
        additionalInfo: "Geolocate Click",
      });
    });

    // Clear Address Selection by clicking reset button
    $("#resetaddressform-header").on("click", function () {
      $("#street1-header").val("");
      $("#street1-header").prop("disabled", false);
      $("#street1-header").lookupServiceAvailability.SelectedAddress = null;

      $("#checkaddress-header").prop("disabled", true);
      $("#resetaddressform-header").addClass("hide");
      $(".apt-col").hide();
    });

    // Clear Address Selection by clicking on the entry element
    $(".wf-address-checker .header-address-checker")
      .find(".address-field-container")
      .on("click", function () {
        // console.log($("#street1-header").prop("disabled"));
        // if ($("#street1-header").prop("disabled")) {
        //   $("#resetaddressform-header").click();
        //   $("#street1-header").focus();
        // }
      });
  }

  var altClasses = [
    "alternative-checker",
    "white-checker",
    "vertical-checker",
    "hp-white-checker",
  ];

  $.each(altClasses, function (key, altClass) {
    if ($("#street1-header" + altClass).length) {
      $("#street1-header" + altClass)
        .lookupServiceAvailability({
          scriptBase: globals.aq_cdn + "/js/aqui",
          addressQualificationBase: "https://addressqualification.nscom.com",
          typeahead_url:
            "https://cdnjs.cloudflare.com/ajax/libs/corejs-typeahead/0.10.3/typeahead.jquery.min.js",
        })
        .on("foundAddressByGooglePlaceId", function (event, addressData) {
          function foundAddressByGooglePlaceIdHandler(
            elem,
            event,
            addressData
          ) {
            //console.log("foundAddressByGooglePlaceIdHandler:", addressData);
            var bindAptTypeAhead_header_alt = function (aptElem) {
              $(aptElem).typeahead("destroy");
              return $(aptElem).typeahead(
                {
                  hint: true,
                  highlight: true,
                  minLength: 0,
                },
                {
                  source: function (query, process) {
                    //console.log("APTS", $(elem).find("#street1").lookupServiceAvailability.aptOptions);
                    x = $.map(
                      $(elem).find("#street1-header" + altClass)
                        .lookupServiceAvailability.aptOptions,
                      function (val, idx) {
                        if (val.value == null) {
                          val.value = "";
                        }
                        return { value: val.value, addrdata: val.addrdata };
                      }
                    );

                    x = _.sortBy(x, "value");

                    process(x);
                  },
                }
              );
            };

            if (
              $(elem).find("#street1-header" + altClass)
                .lookupServiceAvailability.aptOptions.length > 1
            ) {
              //console.log($(this).lookupServiceAvailability.aptOptions.length);
              $(elem).find(".apt-col").show();
              $(elem).addClass("includes-apt");

              bindAptTypeAhead_header_alt(
                $(elem)
                  .find("#aptNo-header" + altClass)
                  .get(0)
              ).on("typeahead:selected", function (event, selection) {
                //console.log('typeahead:selected');
                //console.log(elem, event, selection);
                $.fn.lookupServiceAvailability.aptSelectedHandler(selection);
              });

              $("#aptNo-header" + altClass).one("keydown", adjustDdSize);
              $("#aptNo-header" + altClass).on("focus", function () {
                //console.log('hello');
                var ev = $.Event("keydown");
                ev.keyCode = ev.which = 40;
                $("#aptNo-header" + altClass).trigger(ev);
                return true;
              });
            } else {
              $(elem).find(".apt-elem").hide();
              $(elem).removeClass("includes-apt");
            }
          }

          foundAddressByGooglePlaceIdHandler(
            $(".wf-address-checker." + altClass + " .header-address-checker"),
            event,
            addressData
          );
        })
        .on("addressByGooglePlaceIdNotFound", function (event, selection) {
          //console.log("addressByGooglePlaceIdNotFound:", selection);
        });

      $("#checkaddress-header" + altClass).on("click", function () {
        //console.log("clicked checkaddress");
        // $('#address-checker').toggleClass('open');

        $.fn.aqui.loadGoogleSearchForm($(".aqui-container"));

        // if ($(this).attr("id") !== "checkaddress-headerwhite-checker" && !$("body").hasClass("page-template-template-trimarklanding")) {
        toggleAddressChecker();
        // }

        var minutes = 5;
        var expires = (1 / 24 / 60) * minutes;

        if (Cookies.get("lumos_address_form_count")) {
          var submissionCount = parseInt(
            Cookies.get("lumos_address_form_count")
          );
          submissionCount++;
          Cookies.set("lumos_address_form_count", submissionCount, {
            expires: expires,
          });
        } else {
          Cookies.set("lumos_address_form_count", 1, { expires: expires }); // 5 minutes
        }

        // var altaddr = '';
        // if(!$("#street1-header"+altClass).lookupServiceAvailability.SelectedAddress) {
        //   var addrcomponents = $("#street1-header"+altClass).val().split(',');
        //   altaddr = {};
        //   if(addrcomponents.length >=1) {
        //     altaddr.streetAddress = addrcomponents[0];
        //   }
        //   if(addrcomponents.length >= 2) {
        //     altaddr.city = addrcomponents[1];
        //   }
        //   if(addrcomponents.length >= 3) {
        //     altaddr.state = addrcomponents[2].split(' ')[0];
        //   }
        // }
        if (
          $("#street1-header" + altClass).lookupServiceAvailability
            .SelectedAddress
        ) {
          $.fn.aqui.checkAddress(
            $(".aqui-container"),
            $("#street1-header" + altClass).lookupServiceAvailability
              .SelectedAddress
          );
          // if($(this).attr("id") == "checkaddress-headerwhite-checker"){
          //   var checker = $('.page-template-template-trimarklanding .white-checker');
          //   var addr = $("#street1-header" + altClass).lookupServiceAvailability
          //   .SelectedAddress;
          //   checker.find('h2 strong').text('Lumos Internet Fiber is available!');
          //   checker.find('.additional-copy span').text('Fiber is available in your neighborhood ' + addr.Address + ' in ' + addr.City + '. Let\'s get started');
          //   checker.find('.header-address-checker').hide();
          //   checker.find('.order-button-row').toggleClass('hide');
          //   checker.find('a#checker-change-addr').click(function(e){
          //     e.preventDefault();
          //     checker.find('.order-button-row').toggleClass('hide');
          //     checker.find('.header-address-checker').show();
          //     checker.find('h2 strong').text('Check Availability');
          //     checker.find('.additional-copy span').text('Share your address to check availability.');
          //   });
          // }

          // $.fn.aqui.checkAddress($('.aqui-container'), $("#street1-header").lookupServiceAvailability.SelectedAddress, altaddr);
        } else {
          logNSEvent(
            "ecomm - address checker - Show Second Address Form: No Service Address: " +
              $("#street1-header" + altClass).val()
          );
          logJourney({
            action: "address checker",
            status: "No Service",
            street: $("#street1-header" + altClass).val(),
            additionalInfo: "Show Second Address Form",
          });
          $.fn.aqui.loadDropDownSearchForm($(".aqui-container"));
          // if ($(this).attr("id") == "checkaddress-headerwhite-checker" && $('body').hasClass("page-template-template-trimarklanding")) {
          //   toggleAddressChecker();
          // }
        }

        $("#resetaddressform-header" + altClass).click(); // Reset form on submit
      });

      $("#geolocate-button-header" + altClass).on("click", function () {
        $.geolocation.get({
          win: function (position) {
            var latlng =
              position.coords.latitude + "," + position.coords.longitude;
            var options = $.extend(
              {},
              $.fn.lookupServiceAvailability.defaults,
              options
            );

            // console.log('googleplacelookup 5');

            // var addrPass = $.ajax({
            //   url: "/wp-content/themes/lumos-tidewater/assets/static/lumos_address_qual_pixel_googleplacelookup.html",
            //   async: false,
            //   success: function (response) {
            //     // console.log(response);
            //     return true;
            //   },
            //   error: function () {
            //     window.location.href = "/access-error/";
            //     return false;
            //   },
            // });
            //
            // if (addrPass) {

            $.getJSON(
              options.scriptBase + "/googleplacelookup.php",
              { action: "reverse_geocode", latlng: latlng },
              function (data) {
                if (data.place_id) {
                  $("#street1-header" + altClass).val(
                    data.formatted_address.replace(/, USA/, "")
                  );
                  selection = {
                    place_id: data.place_id,
                    value: data.formatted_address,
                    terms: [],
                  };
                  $.fn.lookupServiceAvailability
                    .googleAddressTypeAheadSelectedHandler(
                      $("#street1-header" + altClass),
                      null,
                      selection
                    )
                    .then(function () {
                      addressData = $.fn.lookupServiceAvailability.aptOptions;
                      foundAddressByGooglePlaceIdHandler(
                        $("#street1-header" + altClass),
                        null,
                        addressData
                      );
                    });
                } else {
                  alert("Accurate geo-location information unavailable.");
                }

                // Remove icon animation
                $("#geolocate-button-header" + altClass)
                  .find(".geolocate-icon")
                  .removeClass("checking");
              }
            );

            // }
          },
          fail: function (error) {
            alert("No location info available. Error code: " + error.code);
            // Remove icon animation
            $("#geolocate-button-header" + altClass)
              .find(".geolocate-icon")
              .removeClass("checking");
          },
        });

        // Add icon animation
        $(this).find(".geolocate-icon").addClass("checking");

        logNSEvent("ecomm - button click - Address Checker: Geolocate Button");
        logJourney({
          action: "button click",
          status: "n/a",
          additionalInfo: "Geolocate Click",
        });
      });

      // Clear Address Selection by clicking reset button
      $("#resetaddressform-header" + altClass).on("click", function () {
        $("#street1-header" + altClass).val("");
        $("#street1-header" + altClass).prop("disabled", false);
        $(
          "#street1-header" + altClass
        ).lookupServiceAvailability.SelectedAddress = null;

        $("#checkaddress-header" + altClass).prop("disabled", true);
        $("#resetaddressform-header" + altClass).addClass("hide");
        $(".apt-col").hide();
      });

      // Clear Address Selection by clicking on the entry element
      $(".wf-address-checker." + altClass + " .header-address-checker")
        .find(".address-field-container")
        .on("click", function () {
          // console.log($("#street1-header" + altClass).prop("disabled"));
          // if ($("#street1-header"+altClass).prop("disabled")) {
          //   $("#resetaddressform-header"+altClass).click();
          //   $("#street1-header"+altClass).focus();
          // }
        });
    }
  });

  function setAdrLookupNoQual() {
    if ($("#street1-headerno-qual-adr-lookup").length) {
      var altClass = "no-qual-adr-lookup";

      $("#street1-headerno-qual-adr-lookup")
        .lookupServiceAvailability({
          scriptBase: globals.aq_cdn + "/js/aqui",
          addressQualificationBase: "https://addressqualification.nscom.com",
          typeahead_url:
            "https://cdnjs.cloudflare.com/ajax/libs/corejs-typeahead/0.10.3/typeahead.jquery.min.js",
          doNotQualify: true,
        })
        .on("foundAddressByGooglePlaceId", function (event, addressData) {
          function foundAddressByGooglePlaceIdHandler(
            elem,
            event,
            addressData
          ) {
            var bindAptTypeAhead_header_alt = function (aptElem) {
              $(aptElem).typeahead("destroy");
              return $(aptElem).typeahead(
                {
                  hint: true,
                  highlight: true,
                  minLength: 0,
                },
                {
                  source: function (query, process) {
                    //console.log("APTS", $(elem).find("#street1").lookupServiceAvailability.aptOptions);
                    x = $.map(
                      $(elem).find("#street1-header" + altClass)
                        .lookupServiceAvailability.aptOptions,
                      function (val, idx) {
                        if (val.value == null) {
                          val.value = "";
                        }
                        return { value: val.value, addrdata: val.addrdata };
                      }
                    );

                    x = _.sortBy(x, "value");

                    process(x);
                  },
                }
              );
            };

            if (
              addressData.length > 1
            ) {
              $(elem).find(".apt-col").show();
              $(elem).addClass("includes-apt");

              bindAptTypeAhead_header_alt(
                $(elem)
                  .find("#aptNo-header" + altClass)
                  .get(0)
              ).on("typeahead:selected", function (event, selection) {
                //console.log('typeahead:selected');
                //console.log(elem, event, selection);
                $.fn.lookupServiceAvailability.aptSelectedHandler(selection);
              });

              $("#aptNo-header" + altClass).one("keydown", adjustDdSize);
              $("#aptNo-header" + altClass).on("focus", function () {
                //console.log('hello');
                var ev = $.Event("keydown");
                ev.keyCode = ev.which = 40;
                $("#aptNo-header" + altClass).trigger(ev);
                return true;
              });
            } else {
              $(elem).find(".apt-elem").hide();
              $(elem).removeClass("includes-apt");
            }
          }

          foundAddressByGooglePlaceIdHandler(
            $(".wf-address-checker." + altClass + " .header-address-checker"),
            event,
            addressData
          );
        })
        .on("addressByGooglePlaceIdNotFound", function (event, selection) {

        });

      $("#checkaddress-header" + altClass).on("click", function () {
        // $.fn.aqui.loadGoogleSearchForm($(".aqui-container"));

        var minutes = 5;
        var expires = (1 / 24 / 60) * minutes;

        if (Cookies.get("lumos_address_form_count")) {
          var submissionCount = parseInt(
            Cookies.get("lumos_address_form_count")
          );
          submissionCount++;
          Cookies.set("lumos_address_form_count", submissionCount, {
            expires: expires,
          });
        } else {
          Cookies.set("lumos_address_form_count", 1, { expires: expires }); // 5 minutes
        }

        if (
          $("#street1-header" + altClass).lookupServiceAvailability
            .SelectedAddress
        ) {
          localStorage.setItem(
            "no_qual_address_universaladdress_id",
            $("#street1-header" + altClass).lookupServiceAvailability
              .SelectedAddress.UniversalAddressID
          );
          localStorage.setItem(
            "no_qual_address_address_id",
            $("#street1-header" + altClass).lookupServiceAvailability
              .SelectedAddress.Id
          );

          // set the address checker to  disabled, show change address button
          $("#resetaddressform-headerno-qual-adr-lookup").removeClass("hide");
          $(".no-qual-adr-lookup .address-field-container").removeClass(
            "d-none"
          );
          $("#checkaddress-headerno-qual-adr-lookup").prop("disabled", true);
          $("#geolocate-button-headerno-qual-adr-lookup").prop(
            "disabled",
            true
          );
          $("#street1-headerno-qual-adr-lookup").prop("disabled", true);
          $("#aptNo-headerno-qual-adr-lookup").prop("disabled", true);
        } else {
          $("#street1-header" + altClass).val("");

          // set items as undefined in local storage
          localStorage.setItem(
            "no_qual_address_universaladdress_id",
            undefined
          );
          localStorage.setItem("no_qual_address_address_id", undefined);
        }

        const event = new Event("lumosNoLookupAddressChange");
        window.dispatchEvent(event);
        // $("#resetaddressform-header" + altClass).click(); // Reset form on submit
      });

      $("#geolocate-button-header" + altClass).on("click", function () {
        $.geolocation.get({
          win: function (position) {
            var latlng =
              position.coords.latitude + "," + position.coords.longitude;
            var options = $.extend(
              {},
              $.fn.lookupServiceAvailability.defaults,
              options
            );

            // console.log('googleplacelookup 5');

            // var addrPass = $.ajax({
            //   url: "/wp-content/themes/lumos-tidewater/assets/static/lumos_address_qual_pixel_googleplacelookup.html",
            //   async: false,
            //   success: function (response) {
            //     // console.log(response);
            //     return true;
            //   },
            //   error: function () {
            //     window.location.href = "/access-error/";
            //     return false;
            //   },
            // });
            //
            // if (addrPass) {

            $.getJSON(
              options.scriptBase + "/googleplacelookup.php",
              { action: "reverse_geocode", latlng: latlng },
              function (data) {
                if (data.place_id) {
                  $("#street1-header" + altClass).val(
                    data.formatted_address.replace(/, USA/, "")
                  );
                  selection = {
                    place_id: data.place_id,
                    value: data.formatted_address,
                    terms: [],
                  };
                  $.fn.lookupServiceAvailability
                    .googleAddressTypeAheadSelectedHandler(
                      $("#street1-header" + altClass),
                      null,
                      selection
                    )
                    .then(function () {
                      addressData = $.fn.lookupServiceAvailability.aptOptions;
                      foundAddressByGooglePlaceIdHandler(
                        $("#street1-header" + altClass),
                        null,
                        addressData
                      );
                    });
                } else {
                  alert("Accurate geo-location information unavailable.");
                }

                // Remove icon animation
                $("#geolocate-button-header" + altClass)
                  .find(".geolocate-icon")
                  .removeClass("checking");
              }
            );

            // }
          },
          fail: function (error) {
            alert("No location info available. Error code: " + error.code);
            // Remove icon animation
            $("#geolocate-button-header" + altClass)
              .find(".geolocate-icon")
              .removeClass("checking");
          },
        });

        // Add icon animation
        $(this).find(".geolocate-icon").addClass("checking");
      });

      // Clear Address Selection by clicking reset button
      $("#resetaddressform-header" + altClass).on("click", function () {
        $("#street1-header" + altClass).val("");
        $("#street1-header" + altClass).prop("disabled", false);
        $(
          "#street1-header" + altClass
        ).lookupServiceAvailability.SelectedAddress = null;

        $("#checkaddress-header" + altClass).prop("disabled", false);
        $("#geolocate-button-headerno-qual-adr-lookup").prop("disabled", false);
        $("#resetaddressform-header" + altClass).addClass("hide");
        $(".wf-address-checker.no-qual-adr-lookup  .apt-col").hide();
        $("#aptNo-headerno-qual-adr-lookup").prop("disabled", false);
      });

      // Clear Address Selection by clicking on the entry element
      $(".wf-address-checker." + altClass + " .header-address-checker")
        .find(".address-field-container")
        .on("click", function () {});
    }
  }

  setAdrLookupNoQual();
})(jQuery);

function setLoadState(isLoading, elem) {
  // set Load State will set the loading state of the address checker elem passed in
  if (isLoading) {
    elem
      .closest(".wf-address-checker, #addressCheckerModal")
      .find(".loading-icon")
      .show();
    elem
      .closest(".wf-floating-address-check, #addressCheckerModal")
      .addClass("loading");
  } else {
    elem
      .closest(".wf-address-checker, #addressCheckerModal")
      .find(".loading-icon")
      .hide();
    elem
      .closest(".wf-floating-address-check, #addressCheckerModal")
      .removeClass("loading");
  }
}

function buildAddress() {
  const houseNo = $("#houseNo").val();
  const streetName = $("#streetName").val();
  const city = $("#city").val();
  const state = $("#state").val();
  const zip = $("#zip").val();
  const aptNum = $("#aptNo").val() ? " Apt " + $("#aptNo").val() : "";

  const addressParts = [];

  const firstLine = [houseNo, streetName, aptNum]
    .filter(Boolean)
    .join(" ")
    .trim();

  if (firstLine) addressParts.push(firstLine);
  if (city) addressParts.push(city);
  if (state) addressParts.push(state);
  if (zip) addressParts.push(zip);

  envConsoleLog("buildAddress", addressParts.join(", "));
  return addressParts.join(", ");
}
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
